module.exports = __webpack_public_path__ + "static/media/bj.5561ec95.svg";